import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const checkAuth =
  secureLocalStorage.getItem("adminInfo") === undefined ||
  secureLocalStorage.getItem("adminInfo") === null
    ? ""
    : `${JSON.parse(secureLocalStorage.getItem("adminInfo")).authToken}`;

const authToken = localStorage.getItem("admins");

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  timeout: 500000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    authToken: checkAuth,
  },
});

const responseBody = (response) => response.data;

const requests = {
  get: (url, body) => instance.get(url, body).then(responseBody),

  post: (url, body, headers) => instance.post(url, body, headers).then(responseBody),

  put: (url, body, headers) =>
    instance.put(url, body, headers).then(responseBody),

  patch: (url, body) => instance.patch(url, body).then(responseBody),

  delete: (url) => instance.delete(url).then(responseBody),
};

export default requests;
